var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('div',{staticClass:"columns columns--cards",style:({
      'background-color': _vm.useBackgroundColor,
      'padding-top': _vm.paddingTop + 'px',
      'padding-bottom': _vm.paddingBottom + 'px'
    })},_vm._l((_vm.blocksByTag),function(block,index){return _c('page-mini-text-block',{key:index,attrs:{"fields":_vm.convertBlockFields(block)}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }